<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="success" class="alert" v-if="alert_tracking === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3">
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <div class="text-right mt-4">
                <router-link to="/newsadd">
                  <v-btn x-large class="grad-success-bg white--text btn_mobile"
                    style="font-size: 18px">เพิ่มข่าวสารใหม่</v-btn>
                </router-link>
              </div>
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="data_test" :footer-props="footer_Props" mobile-breakpoint="0"
                :search="search">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.title }}</td>
                    <td>
                      {{ dataDetail.item.notify_date_start }} -
                      {{ dataDetail.item.notify_date_stop }}
                    </td>
                    <td class="pa-3">
                      <v-switch v-model="dataDetail.item.status"
                        @click="updateStatus(dataDetail.item.id, dataDetail.item.status)" color="success"></v-switch>
                    </td>
                    <td>{{ dataDetail.item.admin_name }}</td>
                    <td class="pa-3">
                      <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1"
                        @click="detail_news_modal(dataDetail.item.id)" title="รายละเอียด">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>

                      <v-btn small height="42" class="grad-warning-bg white--text mr-1 mb-1"
                        @click="edit_news(dataDetail.item.id)" title="แก้ไขข้อมูล">
                        <v-icon>mdi-note-edit-outline</v-icon>
                      </v-btn>

                      <v-btn small height="42" class="grad-danger-bg white--text mr-1 mb-1"
                        @click="deleteNews(dataDetail.item.id)" title="ลบข้อมูล">
                        <v-icon>mdi-delete-empty-outline</v-icon>
                      </v-btn>

                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>

        <!-- จัดส่ง -->
        <v-dialog v-model="detail_success" persistent max-width="900">
          <v-card class="">
            <v-form ref="update" @submit.prevent="wait_for_save">
              <div class="d-flex justify-space-between">
                <v-card-title class="bold pa-5 pb-1">
                  รายละเอียด
                </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text class="pa-5">
                <v-row>
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">พาดหัวข่าว : </span> {{detail_data?.content?.title}}
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1 mt-2">
                    <div class="font-16">
                      <span class="color-grey">รายละเอียดข่าวสาร : </span>
                    </div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div class="font-16" v-html="detail_data?.content?.content">
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <v-col cols="12" class="py-1">
                    <div class="font-16">
                      <span>ระยะเวลาการเผยแพร่ข่าวสาร </span>
                    </div>
                  </v-col>
                  <v-col cols="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่เริ่มต้นข่าวสาร : </span> {{detail_data?.content?.notify_date_start}}
                    </div>
                  </v-col>
                  <v-col cols="6" class="py-1">
                    <div class="font-16">
                      <span class="color-grey">วันที่สิ้นสุดข่าวสาร : </span> {{detail_data?.content?.notify_date_stop}}
                    </div>
                  </v-col>
                </v-row>

                <v-row class="mt-5">
                  <v-col cols="12" class="py-1">
                    <div class="font-16 color-grey">สาขาที่ต้องการแจ้งข่าวสาร</div>
                  </v-col>
                  <v-col cols="12" class="py-1">
                    <div v-for="(item, i) in detail_data?.customer" class="font-16 ml-3" :key="i">{{ i + 1 }}. {{ item.store_name }}</div>
                  </v-col>
                </v-row>

              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn small large class=" grad-danger-bg white--text mr-3" @click="close_modal" style="font-size: 18px">
                  ปิด
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
// import Swal from "sweetalert2";
// import {HTTP} from "@/axios";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "News_information",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      detail_success: false,
      detail_data: {},
      detail_price_success: false,
      overlay: false,
      alert_success: false,
      alert_tracking: false,
      title_type: 0,
      sortDesc: false,
      search: null,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      headers: [],
      data_list: [],
      data_test: [],
      data_detail: [
        {
          product_name: 'inj.GLUCOSE 20 CC for *INJection* 10.-',
          unit: 'ชิ้น',
          price: '10.00',
        },
        {
          product_name: 'ยาดม IZE JELLI BALM 7 G 29.-',
          unit: 'ชิ้น',
          price: '25.00',
        }
      ]

    }
  },
  methods: {
    async deleteNews(id) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(`/news/deletenews/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true
          this.page()
          setTimeout(() => { this.alert_success = false }, 2000)
        }
      });
    },

    async updateStatus(id, status) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get(`/news/updatestatus/${id}/${status ? 1 : 0}`, config).then((res) => {
        if (res.data.successful === true) {
          this.alert_success = true
          setTimeout(() => { this.alert_success = false }, 2000)
        }
      });
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    page() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/news/getnewslist", config).then((res) => {
        if (res.data.successful === true) {
          this.data_test = res.data.newsList;
        }
      });
      //   this.data_test = [
      //   {
      //     news_title: 'โปรโมชั่นใหม่ประจำเดือนพฤศจิกายน',
      //     news_start_end: '01/12/2022 - 31/12/2022',
      //     news_status: 0,
      //     news_user: 'Pharmacare Admin',
      //   },
      //   {
      //     news_title: 'โปรโมชั่นใหม่ประจำเดือนตุลาคม',
      //     news_start_end: '01/10/22 - 31/10/22',
      //     news_status: 0,
      //     news_user: 'Pharmacare Admin',
      //   },
      //   {
      //     news_title: 'โปรโมชั่นใหม่ประจำเดือนกันยายน',
      //     news_start_end: '01/09/22 - 30/09/22',
      //     news_status: 0,
      //     news_user: 'Pharmacare Admin',
      //   },
      // ],

      this.headers = [
        {
          text: 'พาดหัว',
          value: 'title',
          fixed: true,
          width: '250px',
        },
        {
          text: 'วันที่ประกาศ-วันที่สิ้นสุด',
          value: 'notify_date_start',
          fixed: true,
          width: '200px',
        },
        {
          text: 'สถานะข่าวสาร',
          value: 'notify_date_stop',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ผู้สร้าง',
          value: 'admin_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: 'news_tool',
          fixed: true,
          width: '250px',
        },
      ]

    },
    detail_news_modal(id) {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/news/getnewsdetail/" + id, config).then( (res) => {
        if (res.data.successful === true) {
          this.detail_data = res.data.newsdetail;
        }
      });
      this.detail_success = true
    },
    edit_news(id) {
      this.$router.push('newsedit?id=' + id)
    },
    close_modal() {
      this.detail_data = null
      this.detail_success = false
      this.detail_price_success = false
    },
  },
  mounted() {
    this.page(0)
  }
}
</script>

<style scoped>
.bold {
  font-weight: bold;
}

.font-18 {
  font-size: 18px;
}

.font-16 {
  font-size: 16px;
}

.color-grey {
  color: #909090;
}
</style>
